<template>
    <component :is="elementLayout" ref="container">
        <template #element>
            <!--
              Nothing selected yet: offer the crop stage. Once a file sits in the
              element the standard FilePreview below takes over (an existing photo is
              shown as-is; removing it brings the stage back), so a stored photo is
              never silently re-cropped.
            -->
            <selfie-cropper
                v-if="canSelect"
                :options="selfie"
                :translations="selfieTranslations"
                :accept="accept || 'image/*'"
                :field-id="fieldId"
                @cropped="handleSelfieCrop"
                @notify="handleSelfieNotice"
            />

            <!-- Preview -->
            <slot name="preview">
                <FilePreview :key="view" :attrs="aria" />
            </slot>
        </template>

        <!-- Default element slots -->
        <template v-for="(component, slot) in elementSlots" #[slot]><slot :name="slot" :el$="el$"><component :is="component" :el$="el$"/></slot></template>
    </component>
</template>

<script>
/**
 * FileElement template for `selfie` fields, swapped in by `selfiePlugin`.
 *
 * @warn Markup only. vueform renders a template override's `<template>` and nothing
 *   else — the instance stays the element, so `data` (beyond the `merge`/classes
 *   contract below), `computed` and `methods` declared here are never used. Everything
 *   this template binds to therefore comes from the element itself, from
 *   `selfiePlugin` (`selfieTranslations`, `handleSelfieCrop`, `handleSelfieNotice`) or
 *   from the embedded `<selfie-cropper>`, which is a plain component with its own
 *   state. Symptom of getting this wrong: "Cannot read properties of undefined".
 */
export default {
    name: 'FileElement',

    data() {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-file vf-text-type',
                container_removing: 'vf-file-removing',
                button: 'vf-btn vf-btn-secondary',
                button_enabled: '',
                button_disabled: 'vf-btn-disabled',
                button_sm: 'vf-btn-sm',
                button_md: '',
                button_lg: 'vf-btn-lg',
                assertiveText: 'vf-assertive-text',
            },
        }
    },
}
</script>
